import React from "react";
import './clicker-assessment-engine.scss';
import Loading from "../../../components/common/loading/loading";
// import AssessmentHeader from "../assessment-header/assessment-header";
import AssessmentEngineShared from "../../../../shared-storage/assessment-engine";
// import SharedProfile from "../../../../shared-storage/profile";
// import AssessmentApi from "../../apis/assessment";
// import SharedThemeCategory from "../../../shared-storage/category-theme";
// import AssessmentPagination from "../assessment-pagination/assessment-pagination";
import Question from "../question/question";
// import FlagPopup from "../flag-popup/flag-popup";
// import AssessmentEndPopup from "../assessment-end-popup/assessment-end-popup";
import { Constants, FirebaseEvents } from "../../../constants/constants";
import { MyAssessmentContext } from "../clicker-assessment-context/my-assessment-context/clicker-assessment-context";
// import HomeworkApi from "../../apis/homework";
import IndexedDBHelperV2 from "../../../offline/apis/indexDBManager-v2";
import CommonUtils from "../../../utility/common-utilities";
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);
// import FireBaseEvent from '../../../firebase-events/firebase-events';
// import CommonUtils from "../../../utility/common-utilities";
// import StudentAnsweredStatusBoard from "../student-answered-status-board/student-answered-status-board";
// export const MyAssessmentContext = React.createContext({
//     showFinishFooter: false,
//     isAssessment: false,
//     disableNext: false
// })


let onlyonce = false;


class ClickerOfflineAssessmentEngine extends React.Component {

    constructor(props) {
        super(props);

        AssessmentEngineShared.setAssessmentEngine(this)

        // this.userInfo = SharedProfile.getProfile();

        this.meta = this.props.meta

        this.chapterKey = this.meta.chapterKey;
        this.questionSetId = this.meta.questionSetId;
        // this.questionSetId = '66d6b60d6c7da05dcf39ec6c';

        this.chapterTitle = this.meta.chapterTitle
        this.categoryThemeId = this.meta.categoryThemeId;

        //console.log(this.categoryThemeId)

        if (this.meta.selectedChapters) {

            //console.log('::::::selected chapters', this.meta.selectedChapters)

            for (let i = 0; i < this.meta.selectedChapters.length; i++) {
                this.selectedChaptersHash[this.meta.selectedChapters[i].key] = this.meta.selectedChapters[i]
            }
        }

        console.log(this.meta)

        if (this.meta.isResume && this.meta.assessmentActivityId) {

            if (this.meta && (this.meta.from == Constants.EVENT_BASELINE || this.meta.from == Constants.REWARD_EVENT_BASELINE || this.meta.from == Constants.TWO_STEP_EVENT_BASELINE)) {

                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()

            }

            if (this.meta && this.meta.from == Constants.SCHOLARSHIP_EVENT || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.TWO_STEP_EVENT_FINAL) {
                // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

                // if (!this.userInfo.isSubscribed)
                //     this.landingScreenInstance.pauseUserAppTime()
            }

            this.assessmentActivityId = this.meta.assessmentActivityId

            let payload = {
                assessmentActivityId: this.assessmentActivityId,
                isResume: true
            }

            this.getAssessement(payload)
        } else {

            // if(onlyonce) return
            // onlyonce = true

            let payload = {
                chapterKey: this.chapterKey,
                questionSetId: this.questionSetId
            }

            if (this.meta.selectedDuration) {
                payload['duration'] = this.meta.selectedDuration
            }

            if (this.meta.type == 'EVENT') {
                payload.type = 'EVENT'
                payload.assessmentId = this.meta.assessmentId;
            }

            // if (this.meta && this.meta.from == Constants.REFRESHER_COURSE) {
            //     payload.type = Constants.REFRESHER_COURSE
            // }

            // if (this.meta && this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021) {
            //     payload.type = Constants.SCHOLARSHIP_MAY_9_2021
            // }

            // if (this.meta && (this.meta.from == Constants.EVENT_BASELINE || this.meta.from == Constants.REWARD_EVENT_BASELINE || this.meta.from == Constants.TWO_STEP_EVENT_BASELINE)) {
            //     payload.type = Constants.EVENT_BASELINE
            //     payload.eventId = this.meta.eventId

            //     // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

            //     // if (!this.userInfo.isSubscribed)
            //     //     this.landingScreenInstance.pauseUserAppTime()
            // }

            // if (this.meta && this.meta.from == Constants.SCHOLARSHIP_EVENT || this.meta.from == Constants.REWARD_EVENT_FINAL || this.meta.from == Constants.TWO_STEP_EVENT_FINAL) {
            //     payload.type = Constants.SCHOLARSHIP_EVENT
            //     payload.eventId = this.meta.eventId

            //     // this.landingScreenInstance = LandingScreenShared.getLandingScreenInstance()

            //     // if (!this.userInfo.isSubscribed)
            //     //     this.landingScreenInstance.pauseUserAppTime()
            // }

            // if (this.meta && this.meta.from == Constants.MPL_EVENT) {
            //     payload.type = Constants.MPL_EVENT
            //     payload.assessmentId = this.meta.assessmentId;
            //     payload.eventId = this.meta.eventId
            // }

            if (this.meta && this.meta.isFromMyHomework) {
                payload.isFromMyHomework = true
                payload.homeworkActivityId = this.meta.homeworkActivityId
            }

            if (this.meta && this.meta.from && this.meta.from == "MOCK_TEST") {
                payload.type = "MOCK_TEST"
                payload.assessmentId = this.meta.assessmentId;
                payload.eventId = this.meta.eventId
            }

            if (this.meta && this.meta.isFromPracticeCaseStudy) {
                payload.isFromPracticeCaseStudy = true
                payload.practiceActivityId = this.meta.practiceActivityId
            }

            if (this.meta && this.meta.from == 'CLASS_MOCK_TEST') {
                payload.type = 'CLASS_MOCK_TEST'
            }

            if (this.meta && this.meta.from == 'SELECTED_CHAPTER_MOCK_TEST') {
                payload.type = 'SELECTED_CHAPTER_MOCK_TEST'
            }

            if (this.meta && this.meta.from == 'SCIENCE_CLASS_MOCK_TEST') {
                payload.type = 'SCIENCE_CLASS_MOCK_TEST'
            }

            //console.log("Called")
            // payload.type = 'CLICKER_ASSESSMENT'

            let userIds = []

            this.props.studentList.map(item => {
                if (!item.isTeacher) {
                    userIds.push(item.userId)
                }
            })

            if (userIds.length) {
                payload.userIds = userIds.join(',')
            }

            this.getAssessement(payload, true)
        }

    }


    state = {
        questions: [],
        studentList: this.props.studentList,
        currentQuestionNumber: 0,
        currentIndex: 0, // Introduced this key to keep track of current Index when we go previous and comeback to stop there
        showPreviousQuestion: false,

        // questions: [
        //     // {
        //     //     "id": "618222ff2f081330c715fc12"
        //     // },
        //     // {
        //     //     "id": "618223902f081330c715fc16"
        //     // },
        //     // {
        //     //     "id": "618225092f081330c715fc1a"
        //     // },
        //     // {
        //     //     "id": "618225612f081330c715fc1d"
        //     // },
        //     // {
        //     //     "id": "618225c12f081330c715fc20"
        //     // },
        //     // {
        //     //     "id": "618226332f081330c715fc23"
        //     // },
        //     // {
        //     //     "id": "6182269f2f081330c715fc26"
        //     // },
        //     // {
        //     //     "id": "618227302f081330c715fc29"
        //     // },
        //     // {
        //     //     "id": "618227a52f081330c715fc2c"
        //     // },
        //     // {
        //     //     "id": "618228272f081330c715fc2f"
        //     // },
        //     // {
        //     //     "id": "6182326a2f081330c715fc3c"
        //     // },
        //     // {
        //     //     "id": "6182337a2f081330c715fc3f"
        //     // },
        //     // {
        //     //     "id": "618235032f081330c715fc42"
        //     // }
        // ],
        index: 0,
        showFlagPopUp: false,
        showAssessEndPopUp: false,
        remainingTime: 0,
        showTimeUpPopUp: false,
        isFlaggedContentRendering: false,
        currentFlaggedIndex: 0,
        showFinishFooter: false,
        isAssessment: true,
        stepIndex: 0,
        questionDetailsHash: {},
        disableNext: false,
        loading: false,
        currentTime: 0,
        attachments: {},
        questionLoading: true
    };

    flaggedContents = []

    CONTENT_FETCH_LIMIT = 1;
    selectedChaptersHash = {}

    currentTime = 0

    componentDidMount() {

        console.log('offline assessment engine............')

        setTimeout(() => {
            this.setState({ loading: true }, () => {
                this.setState({ loading: false })
            })
        }, 100)
        // this.setZoomOut()
        if (window.AndroidClicker) {
            this.startScanning()
            this.callInInterval()

            if (window.AndroidClicker && window.AndroidClicker.getBluetoothStatus) {
                this.intervalForBLE = setInterval(() => {
                    this.checkBLEStatus()
                }, 0.5 * 60 * 1000);
            }

        }
    }


    checkBLEStatus() {
        const statusJson = window.AndroidClicker.getBluetoothStatus();
        const status = JSON.parse(statusJson);
        //console.log("Bluetooth status:", status);

        // Example: show on UI
        if (!status.receivingSignal) {
            // alert("Bluetooth not receiving signal!");
            console.log('No Bluetooth Signal received.........')
        }
    }

    startScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Started.......from Classwork experience')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            //console.log("AndroidClicker interface not found!");
        }
    };

    callInInterval() {
        // this.interval = setInterval(() => {
        //     this.startScanning()
        // }, 2 * 60 * 1000);
    }

    setZoomOut() {
        // if (window.electron) {
        //     window.electron.ipcRenderer.send('zoom-out', ['ping'])
        // }
    }

    resetZoom() {
        if(window.electron && window.electron.ipcRenderer) {
            window.electron.ipcRenderer.send('reset-zoom', ['ping'])
        }
    }

    componentWillUnmount() {
        if (window.electron) {
            this.resetZoom()
        }
    }


    getAssessement = (payload, assessmentStart) => {
        //console.log(assessmentStart)
        payload = payload ? payload : {}
        console.log(this.meta.assessmentActivityId, this.meta.isResume)
        if (this.meta.isResume && this.meta.assessmentActivityId) {
            dbHelper.getData(Constants.USER_ASSESSMENT_ACTIVITY_STORE, this.meta.assessmentActivityId).then(assessmentActivity => {
                console.log(assessmentActivity)
                let activity = [assessmentActivity]
                let totalTime = activity[0].duration * 60; //Seconds
                let startTime = new Date(activity[0].startTime).getTime(); // Time stamp in milliseconds;
                let now = new Date().getTime(); // Current time in milliseconds;

                let timeDiffInSeconds = Math.floor(((now - startTime) / 1000)) // Milliseconds to seconds

                let questions = activity[0].questionIds

                let questionsBuild = []

                for (let i = 0; i < questions.length; i++) {

                    let doc = {
                        //details: contentHash[questions[i].id],
                        id: questions[i].id,
                        answer: activity[0].question[questions[i].id] ? activity[0].question[questions[i].id].answer : null,
                        isFlagged: activity[0].question[questions[i].id] && activity[0].question[questions[i].id].isFlagged ? true : false,
                    }

                    if (activity[0].question[questions[i].id] && activity[0].question[questions[i].id].studentAnswers) {
                        doc.answer = activity[0].question[questions[i].id].studentAnswers.answer
                        doc.optionsHash = activity[0].question[questions[i].id].studentAnswers.optionsHash
                    }

                    if (activity[0].question[questions[i].id] && activity[0].question[questions[i].id].attachments) {
                        doc['attachments'] = activity[0].question[questions[i].id].attachments
                    }

                    if (questions[i].mandatoryAttachments) {
                        doc['mandatoryAttachments'] = questions[i].mandatoryAttachments
                    }

                    if (questions[i].duration) {
                        doc['duration'] = questions[i].duration
                    }


                    if (questions[i].chapterKey)
                        doc['chapterKey'] = questions[i].chapterKey

                    questionsBuild.push(doc)
                }

                let responseBuild = {
                    remainingTime: totalTime - timeDiffInSeconds,
                    questionIds: questionsBuild,
                    startTime: activity[0].startTime,
                    duration: activity[0].duration ? +activity[0].duration : 0
                }

                if (activity[0].resume && activity[0].resume.questionId)
                    responseBuild['resumeId'] = activity[0].resume.questionId

                let res = responseBuild

                if (res && res.startTime) {
                    this.startTime = res.startTime
                    this.duration = res.duration
                }
                this.homeworkId = activity[0].schoolAssessmentId
                this.assessmentActivityId = this.meta.assessmentActivityId;
                // this.setState({remainingTime : res.remainingTime})
                this.state.remainingTime = res.remainingTime;

                this.ignoreTimeLimit = res && res.ignoreTimeLimit ? true : false

                if (res.questionIds && res.questionIds.length) {

                    if (res.resumeId) {

                        for (let i = 0; i < res.questionIds.length; i++) {
                            if (res.questionIds[i].id == res.resumeId) {
                                this.setState({ index: i, loading: false }, () => {
                                    setTimeout(() => {
                                        if (this.assessmentPaginationComponent) {
                                            this.assessmentPaginationComponent.scrollTo()
                                        }
                                    }, 300)

                                })
                                break;
                            }
                        }
                    }

                    this.getContents(res.questionIds, this.state.index, (err, response) => {
                        console.log('call back called')
                        this.setState({
                            questions: res.questionIds,
                            currentIndex: this.state.index,
                            currentQuestionNumber: this.state.index + 1,
                            showTimeUpPopUp: res.remainingTime == 0 ? true : false
                            // questionLoading : false,
                        }, () => {
                            // this.timer()
                            // this.setState({questionLoading : true})

                            if (this.meta.isResume && res.questionIds[this.state.index].isFlagged) {
                                // console.log(this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.steps)
                                // if (!this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.type) {
                                //     this.setState({ stepIndex: this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.steps.length - 1 })
                                // }
                                // this.ShowCorrectIncorrectScreen()
                            }

                        })

                        this.currentTime = res.remainingTime
                        this.setState({ currentTime: res.remainingTime })
                        if (err)
                            return;
                    })
                }
            }).catch(err => {
                console.log(err)
            })
        } else {
            dbHelper.getData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, payload.homeworkActivityId).then(res => {
                console.log(res)
                res.status = 'IN_PROGRESS'
                this.homeworkId = res.homeworkId
                dbHelper.updateData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, res).then(teacherActivityRes => {
                    console.log(teacherActivityRes)
                    if (res && res.startTime) {
                        this.startTime = res.startTime
                        this.duration = res.duration
                    }

                    this.assessmentActivityId = res.assessmentActivityId;
                    // this.setState({remainingTime : res.remainingTime})
                    this.state.remainingTime = res.remainingTime;

                    this.ignoreTimeLimit = res && res.ignoreTimeLimit ? true : false

                    if (res.questionIds && res.questionIds.length) {

                        if (res.resumeId) {

                            for (let i = 0; i < res.questionIds.length; i++) {
                                if (res.questionIds[i].id == res.resumeId) {
                                    this.setState({ index: i, loading: false }, () => {
                                        setTimeout(() => {
                                            if (this.assessmentPaginationComponent) {
                                                this.assessmentPaginationComponent.scrollTo()
                                            }
                                        }, 300)

                                    })
                                    break;
                                }
                            }
                        }

                        this.getContents(res.questionIds, this.state.index, (err, response) => {
                            console.log('call back called')
                            this.setState({
                                questions: res.questionIds,
                                currentIndex: this.state.index,
                                currentQuestionNumber: this.state.index + 1,
                                showTimeUpPopUp: res.remainingTime == 0 ? true : false
                                // questionLoading : false,
                            }, () => {
                                // this.timer()
                                // this.setState({questionLoading : true})

                                if (this.meta.isResume && res.questionIds[this.state.index].isFlagged) {
                                    // console.log(this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.steps)
                                    if (!this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.type) {
                                        this.setState({ stepIndex: this.state.questionDetailsHash[res.questionIds[this.state.index].id].content.steps.length - 1 })
                                    }
                                    this.ShowCorrectIncorrectScreen()
                                }

                            })

                            this.currentTime = res.remainingTime
                            this.setState({ currentTime: res.remainingTime })
                            if (err)
                                return;
                        })
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        }

    }

    getContents = (questions, index, callback) => {


        if (this.meta && this.meta.isFromMyHomework) {
            this.getHomeworkAssessmentContents(questions, index, callback)
            return
        }

        let ids = [];

        for (let i = 0; i < questions.length; i++) {

            if (index <= i) {
                if (ids.length < this.CONTENT_FETCH_LIMIT) {
                    ids.push(questions[i].id)
                }
            }
        }

        let payload = { _id: ids }

        dbHelper.getAllByIds(Constants.CONTENTS_STORE, ids).then((res) => {
            let questionDetailsHash = this.state.questionDetailsHash;
            //console.log(res)

            for (let i = 0; i < res.length; i++) {

                let content = res[i]
                //console.log(content)

                questionDetailsHash[content._id] = content;

            }

            this.setState({ questionDetailsHash })

            callback && callback(null, res)
        }).catch(err => {
            if (err) {
                callback && callback(err, null)
                return;
            }
        })
    }

    unFlagTheQuestion = () => {

        this.updateActivity({ isFlagged: false }, (err, res) => {

            if (err)
                return;

            let questions = this.state.questions;
            questions[this.state.index]['isFlagged'] = false;
            this.setState({ questions })

        })
    }

    flagTheQuestion = () => {

        this.updateActivity({ isFlagged: true }, (err, res) => {

            if (err)
                return;

            let questions = this.state.questions;
            questions[this.state.index]['isFlagged'] = true;
            this.setState({ questions })

        })
    }


    getHomeworkAssessmentContents = (questions, index, callback) => {

        let ids = [];
        let questionsHash = {}

        for (let i = 0; i < questions.length; i++) {

            questionsHash[questions[i].id] = questions[i]

            // if (index <= i) {
            // if (ids.length < this.CONTENT_FETCH_LIMIT) {
            ids.push(questions[i].id)
            //     }
            // }
        }

        let payload = { ids, questions }

        dbHelper.getAllByIds(Constants.CONTENTS_STORE, ids).then((res) => {
            console.log(res)

            let questionDetailsHash = this.state.questionDetailsHash;


            let quotesData = [
                "“The future belongs to those who believe in the beauty of their dreams.” —Eleanor Roosevelt",
                "“Education is the most powerful weapon which you can use to change the world.” —Nelson Mandela",
                "“Success is the sum of small efforts, repeated day in and day out.” —Robert Collier",
                "“Don’t let what you cannot do interfere with what you can do.” —John Wooden",
                "“The expert in anything was once a beginner.” —Helen Hayes",
                "“The secret of getting ahead is getting started.” —Mark Twain",
                "“Believe you can and you’re halfway there.” —Theodore Roosevelt",
                "“It always seems impossible until it’s done.” —Nelson Mandela",
                "“Failure is the opportunity to begin again more intelligently.” —Henry Ford",
                "“Push yourself, because no one else is going to do it for you.” —Unknown",
                "“Don’t watch the clock; do what it does. Keep going.” —Sam Levenson",
                "“Dream big and dare to fail.” —Norman Vaughan",
                "“There are no shortcuts to any place worth going.” —Beverly Sills",
                "“The man who does not read has no advantage over the man who cannot read.” —Mark Twain",
                "“The beautiful thing about learning is that no one can take it away from you.” —B.B. King",
                "“You don’t have to be great to start, but you have to start to be great.” —Zig Ziglar",
                "“If you are not willing to learn, no one can help you. If you are determined to learn, no one can stop you.” —Zig Ziglar",
                "“A person who never made a mistake never tried anything new.” —Albert Einstein",
                "“Don’t let the fear of striking out hold you back.” —Babe Ruth",
                "“Motivation is what gets you started. Habit is what keeps you going.” —Jim Ryun",
                "“Education is not the learning of facts, but the training of the mind to think.” —Albert Einstein",
                "“Strive for progress, not perfection.” —Unknown",
                "“The harder you work for something, the greater you’ll feel when you achieve it.” —Unknown",
                "“Learning is never done without errors and defeat.” —Vladimir Lenin",
                "“You are never too old to set another goal or to dream a new dream.” —C.S. Lewis",
                "“Develop a passion for learning. If you do, you will never cease to grow.” —Anthony J. D’Angelo",
                "“Opportunities don’t happen, you create them.” —Chris Grosser",
                "“Self-belief and hard work will always earn you success.” —Virat Kohli",
                "“A little progress each day adds up to big results.” —Satya Nani",
                "“Do what you can with all you have, wherever you are.” —Theodore Roosevelt",
                "“Education is the key to unlocking the golden door of freedom.” —George Washington Carver",
                "“Learning is not attained by chance, it must be sought for with ardor and attended to with diligence.” —Abigail Adams",
                "“There is no substitute for hard work.” —Thomas Edison",
                "“Great things are done by a series of small things brought together.” —Vincent van Gogh",
                "“Success doesn’t come to you, you go to it.” —Marva Collins",
                "“Action is the foundational key to all success.” —Pablo Picasso",
                "“Do not wait to strike till the iron is hot; but make it hot by striking.” —William Butler Yeats",
                "“Study hard, for the well is deep, and our brains are shallow.” —Richard Baxter",
                "“Learning without thought is labor lost; thought without learning is perilous.” —Confucius",
                "“Don’t be pushed around by the fears in your mind. Be led by the dreams in your heart.” —Roy T. Bennett",
                "“Education is the passport to the future, for tomorrow belongs to those who prepare for it today.” —Malcolm X",
                "“Winners are not people who never fail, but people who never quit.” —Edwin Louis Cole",
                "“Hard work beats talent when talent doesn’t work hard.” —Tim Notke",
                "“If you can dream it, you can do it.” —Walt Disney",
                "“Do not wait for leaders; do it alone, person to person.” —Mother Teresa",
                "“Excellence is not a skill, it’s an attitude.” —Ralph Marston",
                "“Reading is to the mind what exercise is to the body.” —Joseph Addison",
                "“Your attitude, not your aptitude, will determine your altitude.” —Zig Ziglar",
                "“Start where you are. Use what you have. Do what you can.” —Arthur Ashe",
                "“Shoot for the moon. Even if you miss, you’ll land among the stars.” —Norman Vincent Peale",
                "“Knowledge will bring you the opportunity to make a difference.” —Claire Fagin",
                "“The best way to predict your future is to create it.” —Abraham Lincoln",
                "“Small daily improvements over time lead to stunning results.” —Robin Sharma",
                "“The roots of education are bitter, but the fruit is sweet.” —Aristotle",
                "“Genius is 1% inspiration and 99% perspiration.” —Thomas Edison",
                "“An investment in knowledge pays the best interest.” —Benjamin Franklin",
                "“Discipline is the bridge between goals and accomplishment.” —Jim Rohn",
                "“Success usually comes to those who are too busy to be looking for it.” —Henry David Thoreau",
                "“Do something today that your future self will thank you for.” —Sean Patrick Flanery",
                "“Don’t be afraid to give up the good to go for the great.” —John D. Rockefeller",
                "“Reading is essential for those who seek to rise above the ordinary.” —Jim Rohn",
                "“Formal education will make you a living; self-education will make you a fortune.” —Jim Rohn",
                "“It’s not about how bad you want it. It’s about how hard you’re willing to work for it.” —Unknown",
                "“Success is not final, failure is not fatal: It is the courage to continue that counts.” —Winston Churchill",
                "“The more that you read, the more things you will know.” —Dr. Seuss",
                "“He who opens a school door, closes a prison.” —Victor Hugo",
                "“What we learn with pleasure we never forget.” —Alfred Mercier",
                "“Learning is a treasure that will follow its owner everywhere.” —Chinese Proverb",
                "“All progress takes place outside the comfort zone.” —Michael John Bobak",
                "“Effort only fully releases its reward after a person refuses to quit.” —Napoleon Hill",
                "“Perseverance is not a long race; it is many short races one after the other.” —Walter Elliot",
                "“Education breeds confidence. Confidence breeds hope. Hope breeds peace.” —Confucius",
                "“Work gives you meaning and purpose, and life is empty without it.” —Stephen Hawking",
                "“Doubt kills more dreams than failure ever will.” —Suzy Kassem",
                "“Live as if you were to die tomorrow. Learn as if you were to live forever.” —Mahatma Gandhi",
                "“Your education is a dress rehearsal for a life that is yours to lead.” —Nora Ephron",
                "“Everything you don’t know is something you can learn.” —Unknown",
                "“The more I read, the more I acquire, the more certain I am that I know nothing.” —Voltaire",
                "“Work hard in silence, let success make the noise.” —Frank Ocean",
                "“Don’t limit your challenges. Challenge your limits.” —Jerry Dunn",
                "“Intelligence plus character—that is the goal of true education.” —Martin Luther King Jr.",
                "“Go confidently in the direction of your dreams. Live the life you have imagined.” —Henry David Thoreau",
                "“Learning never exhausts the mind.” —Leonardo da Vinci",
                "“Do not confine your children to your own learning, for they were born in another time.” —Chinese Proverb",
                "“Study the past if you would define the future.” —Confucius",
                "“Try not to become a man of success, but rather try to become a man of value.” —Albert Einstein",
                "“Mistakes are proof that you are trying.” —Unknown",
                "“You always pass failure on the way to success.” —Mickey Rooney",
                "“Failure is success in progress.” —Albert Einstein",
                "“The secret to getting ahead is getting started.” —Agatha Christie",
                "“Courage is not having the strength to go on; it is going on when you don’t have the strength.” —Theodore Roosevelt",
                "“What lies behind us and what lies before us are tiny matters compared to what lies within us.” —Ralph Waldo Emerson",
                "“Champions keep playing until they get it right.” —Billie Jean King",
                "“Quality is not an act, it is a habit.” —Aristotle",
                "“The only place where success comes before work is in the dictionary.” —Vidal Sassoon",
                "“Hard times don’t create heroes. It is during the hard times when the hero within us is revealed.” —Bob Riley",
                "“Patience, persistence and perspiration make an unbeatable combination for success.” —Napoleon Hill",
                "“Be so good they can’t ignore you.” —Steve Martin",
                "“A reader lives a thousand lives before he dies. The man who never reads lives only one.” —George R.R. Martin",
                "“Knowledge is power. Information is liberating. Education is the premise of progress.” —Kofi Annan"
            ]


            if (res.length) {
                res.forEach(contentItem => {
                    let content = contentItem.content

                    let questionDetailsFromSchoolAssessment = questionsHash[contentItem._id]

                    if (questionDetailsFromSchoolAssessment.duration) {
                        content.duration = questionDetailsFromSchoolAssessment.duration
                    }

                    let number = Math.floor(Math.random() * quotesData.length)

                    let quote = quotesData[number]

                    content.quote = quote


                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            delete item.imageUrl
                            item.imageUrl = URL.createObjectURL(item.imageBlob)
                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                delete option.content
                                option.content = URL.createObjectURL(option.imageBlob)
                            }
                        })
                    }


                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    delete item.imageUrl
                                    item.imageUrl = URL.createObjectURL(item.imageBlob)
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                        delete option.content
                                        option.content = URL.createObjectURL(option.imageBlob)
                                    }
                                })
                            }

                        })
                    }

                    questionDetailsHash[contentItem._id] = contentItem;
                })
            }

            // for (let i = 0; i < res.length; i++) {

            //     let content = res[i]

            //     questionDetailsHash[content._id] = content;

            // }

            // console.log(questionDetailsHash)

            this.setState({ questionDetailsHash })

            callback && callback(null, res)
        }).catch(err => {
            if (err) {
                callback && callback(err, null)
                return;
            }

        })
    }

    next = (isResume) => {

        console.log('next called')

        this.answer = this.questionComponent && this.questionComponent.getAnswer();
        this.optionsHash = this.questionComponent && this.questionComponent.getOptionsInfo()

        console.log(this.answer)

        //let question = this.state.questions[this.state.index].details;
        let question = this.state.questionDetailsHash[this.state.questions[this.state.index].id];

        if (this.answer != null && this.state.index >= this.state.currentIndex && !this.state.showPreviousQuestion) {
            let questions = this.state.questions
            questions[this.state.index]['answer'] = this.answer
            questions[this.state.index]['optionsHash'] = this.optionsHash
            this.setState({ questions, showPreviousQuestion: false, questionLoading: false, isResume: false })
            // this.state.questions[this.state.index]['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
            let payload = {
                answer: this.answer,
                optionsHash: this.optionsHash
            }

            if (this.state.questions[this.state.index].attachments && this.state.questions[this.state.index].attachments.length) {
                this.state.attachments[this.state.index] = this.state.questions[this.state.index].attachments
            }

            // if (this.meta && this.meta.isFromMyHomework && question && question.mandatoryAttachments && question.mandatoryAttachments.image && question.mandatoryAttachments.image == true && (!this.state.attachments[this.state.index] || (this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length == 0)) && question.content.isMultiStep && question.content.steps.length - 1 == this.state.stepIndex) {
            //     this.showMedia()
            //     return
            // } else if (this.meta && this.meta.isFromMyHomework && question && question.mandatoryAttachments && question.mandatoryAttachments.image && question.mandatoryAttachments.image == true && (!this.state.attachments[this.state.index] || (this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length == 0)) && !question.content.isMultiStep) {

            //     this.showMedia()
            //     return
            // }

            if (this.state.attachments && this.state.attachments[this.state.index] && this.state.attachments[this.state.index].length) {
                payload['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
                this.state.questions[this.state.index]['attachments'] = this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : []
            }


            if (payload.attachments) {
                this.getSignedUrlForattachments(payload, question)
                return
            }
            this.toggleDisableNext(true)

            this.updateActivity(payload, (err, res) => {

                console.log('udpated the activity')

                if (err) {
                    this.toggleDisableNext(false)
                    return;
                }

                this.toggleDisableNext(false)

                /** If flagged content rendering while press next */
                // if (this.state.isFlaggedContentRendering) {

                //     if (this.state.currentFlaggedIndex !== this.flaggedContents.length - 1) {

                //         if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex) { /** If question is multi step  */
                //             this.setState({ stepIndex: this.state.stepIndex + 1 });
                //         } else {
                //             let nextFlaggedIndex = this.state.currentFlaggedIndex + 1

                //             this.setState({
                //                 currentFlaggedIndex: nextFlaggedIndex,
                //                 index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
                //             }, () => {
                //                 this.setState({ questionLoading: true })
                //             })
                //         }

                //         return;

                //     }
                // }




                if (question.content.isMultiStep) {
                    if (question.content.isMultiStep && question.content.steps.length - 1 == this.state.stepIndex) {
                        console.log('completed multi step')
                        this.ShowCorrectIncorrectScreen()
                    } else if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex) { /** If question is multi step  */
                        let studentList = this.props.studentList

                        studentList.forEach(item => {
                            item.receivedAnswer = false
                            item.isCorrect = null
                            item.value = -1
                            item.answerId = ''
                        })
                        this.setState({ stepIndex: this.state.stepIndex + 1, questionLoading: false, studentList }, () => {
                            this.setState({ questionLoading: true })
                        });
                    }
                } else {
                    if (isResume === true) {// Used to Update Resume - Time Remaining and Number of Users Clicked
                        this.props.delegate && this.props.delegate.showClickerAssessmentList && this.props.delegate.showClickerAssessmentList()
                    } else {
                        this.ShowCorrectIncorrectScreen()
                    }

                }
            })




        } else if (this.state.showPreviousQuestion && this.state.index <= this.state.currentIndex) {
            // To See the Prvious Question

            if (this.answer != null) {
                let questions = this.state.questions
                questions[this.state.index]['answer'] = this.answer
                questions[this.state.index]['optionsHash'] = this.optionsHash
                this.setState({ questions })
            }

            // this.answer = this.state.questions[this.state.index].answer
            // this.optionsHash = this.state.questions[this.state.index].optionsHash
            console.log('Previous Questions Student Response Screen', this.state.index, this.state.currentIndex, this.answer, this.optionsHash)

            // if (question.content.isMultiStep) {
            //     this.multiStepTimeListHash = this.state.questions[this.state.index].multiStepTimeListHash
            //     if (this.question.content.steps.length - 1 === this.state.stepIndex) {
            //         if (this.state.stepIndex)
            //             this.resetStepIndex();

            //         this.ShowCorrectIncorrectModel(false);
            //     } else {

            //         this.nextContinue(this.question, this.answer, false)
            //     }
            // } else {

            let payload = {
                answer: this.answer,
                optionsHash: this.optionsHash
            }

            this.updateActivity(payload, (err, res) => {

                console.log('udpated the activity called from Previous')

                if (err) {
                    this.toggleDisableNext(false)
                    return;
                }

                this.nextQuestionOnCorrectInCorrectAnswer();
            })
            // }

            // this.toggleInvalidAnswerModal(true);
        } else {
            // console.log('inside correct answer')
            // this.ShowCorrectIncorrectScreen()
            // if (this.state.questions[this.state.index].isFlagged) {

            //     /** If flagged content rendering while press next */
            //     if (this.state.isFlaggedContentRendering) {

            //         if (this.state.currentFlaggedIndex !== this.flaggedContents.length - 1) {

            //             let nextFlaggedIndex = this.state.currentFlaggedIndex + 1

            //             this.setState({
            //                 currentFlaggedIndex: nextFlaggedIndex,
            //                 index: this.flaggedContents[nextFlaggedIndex], stepIndex: 0, questionLoading: false
            //             }, () => {
            //                 this.setState({ questionLoading: true })
            //             })

            //             return;

            //         }
            //     }

            //     if (this.state.index !== this.state.questions.length - 1) {

            //         if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {

            //             this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
            //                 this.setState({ questionLoading: true })
            //             })

            //         } else {
            //             this.toggleDisableNext(true)
            //             this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

            //                 if (err) {
            //                     this.toggleDisableNext(false)
            //                     return;
            //                 }

            //                 this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
            //                     this.setState({ questionLoading: true })
            //                 })
            //                 this.toggleDisableNext(false)
            //             })

            //         }

            //     } else {
            //         this.flaggedContents = this.getFlaggedContentIndex()
            //         if (this.meta && this.meta.from === 'CASE STUDY') {
            //             this.onFinish()
            //         } else {
            //             this.showAssessEndPopUp()
            //         }
            //     }

            // } else {

            //     if (this.meta && this.meta.from === 'CASE STUDY') {
            //         this.toggleInvalidAnswerModal(true)
            //     } else {
            //         this.showFlagPopUp()
            //     }
            // }
        }
    }


    updateActivity = (payload, callback) => {

        let questionId = this.state.questions[this.state.index].id;

        payload = {
            assessmentActivityId: this.assessmentActivityId,
            questionId,
            ...payload
        }


        dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', this.homeworkId).then(activity => {
            dbHelper.getData(Constants.CONTENTS_STORE, questionId).then(contentRes => {
                let contents = [contentRes]
                let questionId = payload.questionId;
                let userAnswerHash = payload.answer.answer
                let isFlagged = payload.isFlagged;
                let startTime = new Date()

                let userAnswerHashBySteps = {}

                if (userAnswerHash.steps && userAnswerHash.steps.length) {
                    for (let i = 0; i < userAnswerHash.steps.length; i++) {
                        let stepItem = userAnswerHash.steps[i]
                        for (let key in stepItem.answer) {
                            let answer = stepItem.answer[key]
                            if (!userAnswerHashBySteps[key]) {
                                userAnswerHashBySteps[key] = {
                                    answer: {
                                        id: userAnswerHash.id,
                                        steps: [{ answer: answer.answer.answer, timeTakenToAnswer: answer.answer.timeTakenToAnswer }],
                                        userDeviceMacId: answer.answer.userDeviceMacId
                                    }
                                }

                            } else {
                                userAnswerHashBySteps[key].answer.steps[i] = { answer: answer.answer.answer, timeTakenToAnswer: answer.answer.timeTakenToAnswer }
                            }
                        }
                    }

                    userAnswerHash = userAnswerHashBySteps
                }


                for (let i = 0; i < activity.length; i++) {
                    let userActivity = activity[i]

                    if (userAnswerHash[userActivity.userId] || !userActivity.teacherAssessmentActivityId) {
                        let answer = userAnswerHash[userActivity.userId]

                        userActivity.resume[`questionId`] = questionId
                        userActivity[`updatedTime`] = new Date()
                        if (this.state.index === 0) {
                            userActivity[`startTime`] = new Date()
                        }

                        // if (body.hasOwnProperty('isFlagged'))
                        //     userActivity[`question.${questionId}.isFlagged`] = isFlagged ? true : false;

                        if (answer) {
                            if (answer.pauseDetails) {
                                userActivity.question[`${questionId}`] = {
                                    pauseDetails: answer.pauseDetails,
                                    isFlagged: isFlagged ? true : true
                                }
                            } else {
                                userActivity.question[`${questionId}`] = {
                                    answer: '',
                                    status: '',
                                    userDeviceMacId: ''
                                }
                                userActivity.question[`${questionId}`].answer = answer.answer;

                                let isWrong = CommonUtils.validateAnswer(contents[0], answer.answer)

                                if (isWrong) {
                                    userActivity.question[`${questionId}`].status = 'IN_CORRECT';
                                } else {
                                    userActivity.question[`${questionId}`].status = 'CORRECT';
                                }
                                userActivity.question[`${questionId}`].userDeviceMacId = answer.answer.userDeviceMacId
                                // userActivity.question[`${questionId}.timeTakenToAnswer`] = answer.answer.timeTakenToAnswer
                            }


                        } else {
                            userActivity.question[`${questionId}`] = {
                                isFlagged: isFlagged ? true : true,
                                studentAnswers: { answer: payload.answer, optionsHash: payload.optionsHash }
                            }
                        }

                        if (answer && !contents[0].content.type && contents[0].content.practice && contents[0].content.practice.id === 'CASE STUDY') {

                            let caseStudySkillWiseInfo = CommonUtils.validateAnswerForMultiStepForStudentReport(contents[0], answer.answer)
                            userActivity.caseStudySkill[`${questionId}`].caseStudySkillWiseInfo = caseStudySkillWiseInfo
                        }
                    }
                }
                console.log(activity)
                dbHelper.updateBulkData(Constants.USER_ASSESSMENT_ACTIVITY_STORE, activity).then(updatedActivityRes => {
                    console.log('activity updated......')
                    callback(null, updatedActivityRes)
                })
            })
        }).catch(err => {
            console.log(err)
            callback(err, null)
        })
        // AssessmentApi.updateMyClickerAsssemetActicity(payload).then((res) => {
        //     callback(null, res)
        // }).catch(err => {
        //     callback(err, null)
        // })
    }

    toggleDisableNext = (value) => {
        this.setState({ disableNext: value })
    }

    ShowCorrectIncorrectScreen = (isCorrect) => {
        this.isCorrect = isCorrect;
        // this.setState({ showCorrectIncorrectScreen: true, questionLoading: false }, () => {
        //     this.setState({ questionLoading: true })
        // })
        this.nextQuestionOnCorrectInCorrectAnswer()
    }

    hideCorrectIncorrectScreen() {
        this.setState({ showCorrectIncorrectScreen: false });
    }

    nextQuestionOnCorrectInCorrectAnswer() {

        // if (this.question.content.isMultiStep) {
        //     //console.log('continue 200', this.question)
        //     if (this.isCorrect)
        //         this.nextContinue(this.question, this.answer, false);
        //     else
        //         this.nextContinue(this.question, this.answer, true);

        // } else {
        //console.log('normal next continue called...')
        this.nextContinue();
        // }

        this.setState({ showCorrectIncorrectScreen: false, isReadOnly: false, questionLoading: false });
    }


    nextContinue = () => {
        let question = this.state.questionDetailsHash[this.state.questions[this.state.index].id];

        if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex) { /** If question is multi step  */
            // console.log('inside next multi step')
            this.setState({ stepIndex: this.state.stepIndex + 1, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
            });
        } else {

            if (this.state.stepIndex)
                this.resetStepIndex();

            if (this.state.index !== this.state.questions.length - 1) {
                // if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {

                //     // console.log('updated the existing content multi step')

                //     this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                //         this.setState({ questionLoading: true })
                //     })

                // } else {

                this.toggleDisableNext(true)

                console.log('updated the content')

                this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

                    if (err) {
                        this.toggleDisableNext(false)
                        return;
                    }

                    let studentList = this.props.studentList

                    studentList.forEach(item => {
                        item.receivedAnswer = false
                        item.isCorrect = null
                        item.value = -1
                        item.answerId = ''
                    })

                    this.setState({
                        index: this.state.index + 1, stepIndex: 0, questionLoading: false, studentList,
                        showPreviousQuestion: this.state.index + 1 === this.state.currentIndex ? false : this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false,
                        currentQuestionNumber: this.state.currentQuestionNumber + 1,
                    }, () => {
                        this.setState({ questionLoading: true })
                    })
                    this.toggleDisableNext(false)
                })
                // }


            } else {
                // this.flaggedContents = this.getFlaggedContentIndex()
                // if (this.meta && this.meta.from === 'CASE STUDY') {
                //     this.onFinish()
                // } else {
                //     this.showAssessEndPopUp()
                // }

                console.log('finish pressed.............')

                this.onFinish()
            }
        }

    }

    previous(isReadOnly = false) {

        console.log('previous Pressed', isReadOnly)
        // let question = this.state.questions[this.state.index].details;
        let question = this.state.questionDetailsHash[this.state.questions[this.state.index].id]
        let studentList = this.props.studentList

        let userIdAnswerHash = this.state.questions[this.state.index - 1].answer.answer // Previous Question Answer Hash

        studentList.forEach(item => {
            if (userIdAnswerHash[item.userId]) {
                let answer = userIdAnswerHash[item.userId].answer
                item.receivedAnswer = true
                item.value = -1
                item['isCorrect'] = answer.isCorrect
                item.answerId = answer.answer[0].id
            } else {
                item.receivedAnswer = false
                item.value = -1
                item.answerId = ''
            }
        })

        if (isReadOnly === true) {
            console.log('inside readonly')
            if (this.state.stepIndex) {
                this.resetStepIndex()
            }

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentIndex: this.state.index + 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }
            return
        }


        if (question.content.isMultiStep && this.state.stepIndex !== 0) {
            //console.log("inside Previous Step", this.state.stepIndex)

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentStepIndex: this.state.stepIndex,
                    stepIndex: this.state.stepIndex - 1,
                    currentIndex: this.state.index,
                    showMainQuestion: false,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    stepIndex: this.state.stepIndex - 1,
                    showMainQuestion: this.state.stepIndex - 1 === 0 ? false : true,
                    // index: this.state.index - 1,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }

        } else if (question.content.isMultiStep && this.state.stepIndex === 0 && !this.state.showMainQuestion) {
            this.setState({
                stepIndex: 0,
                showMainQuestion: true,
                // index: this.state.index - 1,
                // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                showPreviousQuestion: true,
                questionLoading: false
            }, () => {
                this.setState({ questionLoading: true })
            });
        }
        // else if (question.content.isMultiStep && this.state.stepIndex === 0 && this.state.showMainQuestion
        //     && !this.state.questions[this.state.index].answer
        // ) {
        //     this.setState({
        //         stepIndex: 0,
        //         showMainQuestion: true,
        //         // index: this.state.index - 1,
        //         // currentQuestionNumber: this.state.currentQuestionNumber - 1,
        //         showPreviousQuestion: true,
        //         questionLoading: false
        //     }, () => {
        //         this.setState({ questionLoading: true })
        //     });
        // }
        else {

            if (this.state.index != 0) {
                console.log('inside Previous', this.state.index)


                if (this.state.stepIndex) {
                    this.resetStepIndex()
                }

                if (!this.state.showPreviousQuestion) {
                    this.setState({
                        currentIndex: this.state.index,
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false,
                        studentList
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                } else {
                    this.setState({
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false,
                        studentList
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                }
            }
        }
    }


    resetStepIndex = () => {
        this.setState({ stepIndex: 0 });
    }

    goToClickerAssessmentList() {
        this.next(true)
    }




    onClickPage = (page) => {

        if (this.state.stepIndex) {
            this.setState({ stepIndex: 0 })
        }

        let answer = this.questionComponent && this.questionComponent.getAnswer();

        if (answer) {
            this.state.questions[this.state.index]['answer'] = answer
            let payload = {
                answer
            }
            this.updateActivity(payload, (err, res) => {
                if (err)
                    return;
                this.onClickPageContinue(page)
            })
        } else {

            this.onClickPageContinue(page)
        }
    }

    onClickPageContinue = (page) => {
        if (this.state.questionDetailsHash[this.state.questions[page - 1].id]) {

            this.setState({ index: page - 1, isFlaggedContentRendering: false, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
            })
        } else {
            this.getContents(this.state.questions, page - 1, (err, response) => {

                if (err)
                    return;

                this.setState({ index: page - 1, isFlaggedContentRendering: false, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                })
            })
        }
    }

    getFlaggedContentIndex = () => {
        let flaggedIndex = [];

        for (let i = 0; i < this.state.questions.length; i++) {
            let question = this.state.questions[i];

            if (question.isFlagged)
                flaggedIndex.push(i)
        }

        return flaggedIndex
    }

    showFlagPopUp = () => {
        //console.log('flag')
        this.setState({ showFlagPopUp: true })
    }

    hideFlagPopUp = (callback) => {
        this.setState({ showFlagPopUp: false }, () => callback && callback())
    }

    showAssessEndPopUp = () => {
        this.setState({ showAssessEndPopUp: true })
    }

    hideAssessEndPopUp = () => {
        this.setState({ showAssessEndPopUp: false })
    }

    onFinish = () => {

        // let answer = this.questionComponent && this.questionComponent.getAnswer();

        // if (answer) {
        //     this.state.questions[this.state.index]['answer'] = answer
        //     let payload = {
        //         answer
        //     }
        //     this.updateActivity(payload, (err, res) => {

        //         console.log(err)

        //         if (err)
        //             return;

        //         this.onPressFinish()
        //     })

        // } else {
        this.onPressFinish()
        // }

    }


    onPressFlagYes = () => {
        let questions = this.state.questions;
        questions[this.state.index]['isFlagged'] = true;
        this.setState({ questions })

        this.updateActivity({ isFlagged: true }, (err, res) => {

            if (err)
                return;

            this.hideFlagPopUp(() => {

                if (this.state.index !== this.state.questions.length - 1) {

                    if (this.state.questionDetailsHash[this.state.questions[this.state.index + 1].id]) {
                        this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                            this.setState({ questionLoading: true })
                        })
                    } else {

                        this.getContents(this.state.questions, this.state.index + 1, (err, response) => {

                            if (err)
                                return;

                            this.setState({ index: this.state.index + 1, stepIndex: 0, questionLoading: false }, () => {
                                this.setState({ questionLoading: true })
                            })
                        })

                    }
                } else {
                    //console.log('inside review of flagged assessment')

                    if (this.meta && this.meta.from === 'CASE STUDY') {
                        this.onFinish()
                    } else {
                        setTimeout(() => {
                            this.flaggedContents = this.getFlaggedContentIndex()
                            this.showAssessEndPopUp()
                        }, 500)
                    }

                }
            })
        })
    }


    onPressContinue = () => {
        if (this.state.questionDetailsHash[this.state.questions[this.flaggedContents[0]].id]) {
            this.setState({
                index: this.flaggedContents[0],
                showAssessEndPopUp: false,
                isFlaggedContentRendering: true,
                currentFlaggedIndex: 0,
                showFinishFooter: true, stepIndex: 0, questionLoading: false
            }, () => {
                this.setState({ questionLoading: true })
                if (this.assessmentPaginationComponent) {
                    this.assessmentPaginationComponent.scrollTo()
                }
            })
        } else {
            this.getContents(this.state.questions, this.flaggedContents[0], (err, response) => {

                if (err)
                    return;

                this.setState({
                    index: this.flaggedContents[0],
                    showAssessEndPopUp: false,
                    isFlaggedContentRendering: true,
                    currentFlaggedIndex: 0,
                    showFinishFooter: true, stepIndex: 0, questionLoading: false
                }, () => {

                    this.setState({ questionLoading: true })

                    if (this.assessmentPaginationComponent) {
                        this.assessmentPaginationComponent.scrollTo()
                    }
                })
            })
        }
    }

    assessMyAssessment = (callback) => {

        let payload = {
            assessmentActivityId: this.assessmentActivityId
        }


        if (this.meta.isFromMyHomework) {
            payload.homeworkActivityId = this.meta.homeworkActivityId
            payload.isFromMyHomework = true
        }

        if (this.meta.isFromPracticeCaseStudy) {
            payload.practiceActivityId = this.meta.practiceActivityId
            payload.isFromPracticeCaseStudy = true
        }



        // if (!this.userInfo.prepkitGuaranteeAssessmentActivity || (this.userInfo.prepkitGuaranteeAssessmentActivity && this.userInfo.prepkitGuaranteeAssessmentActivity.class && this.userInfo.prepkitGuaranteeAssessmentActivity.class != this.userInfo.class)) {
        //     payload.guaranteeAssessment = true
        // }

        let userIds = []

        this.props.studentList.map(item => {
            if (!item.isTeacher && item.userDeviceMacId.length === 17) {
                userIds.push(item.userId)
            }
        })

        let totalActiveClickers = userIds.length

        payload.totalActiveClickers = totalActiveClickers

        dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', this.homeworkId).then(activity => {


            if (activity[0].status === 'COMPLETED') {
                callback("err", null)
                return;
            }


            let ids = [];

            let questionsList = this.state.questions

            for (let i = 0; i < questionsList.length; i++) {
                ids.push(questionsList[i].id)
            }

            dbHelper.getAllByIds(Constants.CONTENTS_STORE, ids).then(contents => {

                let contentHash = {}

                for (let i = 0; i < contents.length; i++) {
                    let content = contents[i];
                    contentHash[content._id.toString()] = content;
                }

                let now = new Date().getTime()

                let assessmentQuestionWiseStudentInfo = [], assessmentQuestionWiseStudentInfoHash = {}

                let userActivityUpdatePayload = []

                let userAssessmentactivity = activity, uniqueClickerAttenedHash = {}

                let userHomeworkActivityUpdatePayload = [], userObjectIdList = [], userFeedBack = []


                for (let i = 0; i < userAssessmentactivity.length; i++) {

                    let correct = 0;
                    let inCorrect = 0;
                    let notAttempted = 0;
                    let totalMark = 0;
                    let markScored = 0;
                    let marksHash = {}

                    let questionGroupBySkill = {}
                    let caseStudyQuestionSkillGrouping = {}

                    // let filterPayload = {
                    //     _id: userAssessmentactivity[i]._id
                    // }

                    // userObjectIdList.push(ObjectID(userAssessmentactivity[i].userId))

                    let questionNumber = 0, feedbackobj = {}

                    for (let j = 0; j < userAssessmentactivity[i].questionIds.length; j++) {

                        let question = userAssessmentactivity[i].questionIds[j];
                        let activity = userAssessmentactivity[i]

                        // for Feeback 

                        if (j >= 26) {
                            questionNumber += 1
                            let content = contentHash[question.id]
                            let optionsHash = {}
                            content.content.options.forEach(item => optionsHash[item.id] = item)

                            if (feedbackobj.Question1 && activity.question[question.id] && activity.question[question.id].answer) {
                                let option = optionsHash[activity.question[question.id].answer.answer[0].id]
                                feedbackobj = {
                                    ...feedbackobj,
                                    [`Question${questionNumber}`]: content.content.title.replace(/(<([^>]+)>)/ig, ''),
                                    [`Answer${questionNumber}`]: option.content.replace(/(<([^>]+)>)/ig, '')
                                }

                            } else if (activity.question[question.id] && activity.question[question.id].answer) {
                                console.log(activity.question[question.id].answer.answer[0].id)
                                let option = optionsHash[activity.question[question.id].answer.answer[0].id]
                                feedbackobj[`Question${questionNumber}`] = content.content.title.replace(/(<([^>]+)>)/ig, '')
                                feedbackobj[`Answer${questionNumber}`] = option.content.replace(/(<([^>]+)>)/ig, '')
                                feedbackobj.userId = activity.userId
                            }
                        }

                        if (j === 29 && feedbackobj.Question1) {
                            userFeedBack.push(feedbackobj)
                        }


                        if (j >= 26) continue; // Hard Coded to Not show the Feedback Questions Percentage in the Assessment End Screen // We will remove this code after implementation of feedback questions in Jigyasa assessment

                        if (activity.question[question.id] && activity.question[question.id].answer) {

                            let attendedQuestion = {};

                            if (contentHash[question.id]) {
                                attendedQuestion = {
                                    id: question.id,
                                    skill: contentHash[question.id].skill ? contentHash[question.id].skill.title : "",
                                    mark: contentHash[question.id].content.mark ? +contentHash[question.id].content.mark : 0
                                }
                            }


                            if (activity.question[question.id].status == 'CORRECT') {
                                correct = correct + 1;

                                if (!uniqueClickerAttenedHash[activity.userId] && activity.question[question.id].userDeviceMacId) {
                                    uniqueClickerAttenedHash[activity.userId] = true
                                }

                                if (contentHash[question.id] && contentHash[question.id].content.mark) {
                                    markScored += contentHash[question.id].content.mark ? +contentHash[question.id].content.mark : 0;
                                }

                                if (assessmentQuestionWiseStudentInfoHash[question.id] && assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion) {
                                    assessmentQuestionWiseStudentInfoHash[question.id].correct += 1
                                    assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount += 1
                                    assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion += 1
                                } else {
                                    assessmentQuestionWiseStudentInfoHash[question.id] = { correct: 1, correctStudentsCount: 1, totalUserAttenedQuestion: 1 }
                                }

                                // assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion)

                                assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = this.calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, totalActiveClickers)

                                if (!marksHash[contentHash[question.id].content.mark]) {
                                    marksHash[contentHash[question.id].content.mark] = 1
                                } else {
                                    marksHash[contentHash[question.id].content.mark] = marksHash[contentHash[question.id].content.mark] + 1
                                }

                                if (questionGroupBySkill[attendedQuestion.skill] && questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark) {
                                    // questionGroupBySkill[attendedQuestion.skill].question.push(attendedQuestion);
                                    questionGroupBySkill[attendedQuestion.skill].totalMark = questionGroupBySkill[attendedQuestion.skill].totalMark + attendedQuestion.mark;
                                    questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark = questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark + attendedQuestion.mark;
                                }
                                else {
                                    questionGroupBySkill[attendedQuestion.skill] = {}
                                    // questionGroupBySkill[attendedQuestion.skill].question = [attendedQuestion];
                                    questionGroupBySkill[attendedQuestion.skill].totalMark = attendedQuestion.mark;
                                    questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark = attendedQuestion.mark;
                                }
                                questionGroupBySkill[attendedQuestion.skill].percentage = this.calculatePercentage(questionGroupBySkill[attendedQuestion.skill].totalMark, questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark)
                            }

                            if (activity.question[question.id].status == 'IN_CORRECT') {
                                inCorrect = inCorrect + 1;

                                if (!uniqueClickerAttenedHash[activity.userId] && activity.question[question.id].userDeviceMacId) {
                                    uniqueClickerAttenedHash[activity.userId] = true
                                }

                                if (questionGroupBySkill[attendedQuestion.skill] && questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark) {
                                    // questionGroupBySkill[attendedQuestion.skill].question.push(attendedQuestion);
                                    questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark = questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark + attendedQuestion.mark;
                                }
                                else {
                                    questionGroupBySkill[attendedQuestion.skill] = {}
                                    // questionGroupBySkill[attendedQuestion.skill].question = [attendedQuestion];
                                    questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark = attendedQuestion.mark;
                                }
                                questionGroupBySkill[attendedQuestion.skill].totalMark = questionGroupBySkill[attendedQuestion.skill].totalMark ? questionGroupBySkill[attendedQuestion.skill].totalMark : 0;
                                questionGroupBySkill[attendedQuestion.skill].percentage = this.calculatePercentage(questionGroupBySkill[attendedQuestion.skill].totalMark, questionGroupBySkill[attendedQuestion.skill].totalAssessmentMark)

                                console.log('contentHash[question.id].content.negativeMark', contentHash[question.id].content.negativeMark)
                                if (contentHash[question.id] && contentHash[question.id].content.negativeMark) {
                                    markScored -= contentHash[question.id].content.negativeMark ? parseInt(contentHash[question.id].content.negativeMark) : 0
                                }

                                if (assessmentQuestionWiseStudentInfoHash[question.id] && assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion) {
                                    assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion += 1
                                } else {
                                    assessmentQuestionWiseStudentInfoHash[question.id] = { correct: 0, correctStudentsCount: 0, totalUserAttenedQuestion: 1 }
                                }

                                // assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion)
                                assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = this.calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, totalActiveClickers)

                            }
                        } else {
                            notAttempted = notAttempted + 1;

                            // if (!uniqueClickerAttenedHash[activity.userId] && activity.question[question.id].userDeviceMacId) {
                            //     uniqueClickerAttenedHash[activity.userId] = true
                            // }

                            if (i != 0) {
                                if (assessmentQuestionWiseStudentInfoHash[question.id] && assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion) {
                                    assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion += 1
                                } else {
                                    assessmentQuestionWiseStudentInfoHash[question.id] = { correct: 0, correctStudentsCount: 0, totalUserAttenedQuestion: 1 }
                                }
                                // assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, assessmentQuestionWiseStudentInfoHash[question.id].totalUserAttenedQuestion)
                                assessmentQuestionWiseStudentInfoHash[question.id].clearedPercentage = this.calculatePercentage(assessmentQuestionWiseStudentInfoHash[question.id].correctStudentsCount, totalActiveClickers)

                            }
                        }

                        if (contentHash[question.id] && contentHash[question.id].content.mark) {
                            totalMark += contentHash[question.id].content.mark ? +contentHash[question.id].content.mark : 0;
                        }


                        if (contentHash[question.id] &&
                            contentHash[question.id].content &&
                            contentHash[question.id].content.practice &&
                            contentHash[question.id].content.practice.id === 'CASE STUDY' &&
                            activity.caseStudySkill && activity.caseStudySkill[question.id]) {

                            let caseStudySkill = activity.caseStudySkill[question.id].caseStudySkillWiseInfo

                            for (let j = 0; j < caseStudySkill.length; j++) {
                                let skillInfo = caseStudySkill[j]
                                if (skillInfo.status === 'CORRECT') {
                                    if (caseStudyQuestionSkillGrouping[skillInfo.skill] && caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal) {
                                        // questionGroupBySkill[attendedQuestion.skill].question.push(attendedQuestion);
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal = caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal + 1;
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect = caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect + 1;
                                    }
                                    else {
                                        caseStudyQuestionSkillGrouping[skillInfo.skill] = {}
                                        // questionGroupBySkill[attendedQuestion.skill].question = [attendedQuestion];
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal = 1;
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect = 1;
                                    }
                                    let skillPercentage = this.calculatePercentage(caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect, caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal)
                                    caseStudyQuestionSkillGrouping[skillInfo.skill].skillCleared = skillPercentage > 51 ? true : false
                                }

                                if (skillInfo.status === 'IN_CORRECT') {
                                    if (caseStudyQuestionSkillGrouping[skillInfo.skill] && caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal) {
                                        // questionGroupBySkill[attendedQuestion.skill].question.push(attendedQuestion);
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal = caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal + 1;

                                    }
                                    else {
                                        caseStudyQuestionSkillGrouping[skillInfo.skill] = {}
                                        // questionGroupBySkill[attendedQuestion.skill].question = [attendedQuestion];
                                        caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal = 1;
                                    }
                                    caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect = caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect ? caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect : 0;
                                    let skillPercentage = this.calculatePercentage(caseStudyQuestionSkillGrouping[skillInfo.skill].totalCorrect, caseStudyQuestionSkillGrouping[skillInfo.skill].skillTotal)
                                    caseStudyQuestionSkillGrouping[skillInfo.skill].skillCleared = skillPercentage > 51 ? true : false
                                }
                            }
                        }
                    }

                    let marksArray = []

                    if (Object.keys(marksHash).length > 0) {
                        for (var key in marksHash) {
                            marksArray.push({ marks: key, count: marksHash[key] })
                        }
                    }

                    let skillWisePercentage = {}


                    if (Object.keys(questionGroupBySkill).length > 0) {
                        for (var key in questionGroupBySkill) {
                            skillWisePercentage[key] = questionGroupBySkill[key].percentage
                        }
                    }

                    let timeTaken = Math.floor(((now - userAssessmentactivity[i].startTime) / 1000))

                    userAssessmentactivity[i] = {
                        ...userAssessmentactivity[i],
                        status: 'COMPLETED',
                        finishTime: new Date(),
                        correct,
                        inCorrect,
                        notAttempted,
                        totalMark,
                        markScored,
                        marksArray,
                        timeTaken,
                        skillWisePercentage,
                        userAssessedFrom: "SCHOOL PORTAL CLICKER OFFLINE",
                        caseStudySkillCleard: {}
                    }

                    if (caseStudyQuestionSkillGrouping) {
                        userAssessmentactivity[i]['caseStudySkillCleard'] = caseStudyQuestionSkillGrouping
                    }

                    // userActivityUpdatePayload.push({ updateOne: { filter: filterPayload, update: updatePayload, upsert: true } })
                }

                let uniqueClicker = Object.keys(uniqueClickerAttenedHash)

                let number = 0
                for (let key in assessmentQuestionWiseStudentInfoHash) {
                    number += 1
                    let studentDetail = assessmentQuestionWiseStudentInfoHash[key]
                    let content = contentHash[key]
                    studentDetail.clearedPercentage = this.calculatePercentage(studentDetail.correctStudentsCount, uniqueClicker.length)
                    studentDetail.teacherAssessmentActivityId = this.meta.assessmentActivityId
                    assessmentQuestionWiseStudentInfo.push({ ...studentDetail, questionId: key, questionNumber: `Q${number}`, questionTitle: content.content.title.replace(/(<([^>]+)>)/ig, '') })
                }

                dbHelper.updateBulkData(Constants.USER_ASSESSMENT_ACTIVITY_STORE, userAssessmentactivity).then(updatedRes => {
                    console.log('assess Questions Completed')
                    let res = {
                        data: {
                            assessmentQuestionWiseStudentInfo
                        }
                    }

                    dbHelper.getData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, this.meta.homeworkActivityId).then(homeworkActivity => {

                        homeworkActivity.status = 'COMPLETED'
                        homeworkActivity = {
                            ...homeworkActivity,
                            pendingSync: true
                        }

                        dbHelper.updateData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, homeworkActivity).then(homeworkActivityUpdateRes => {
                            console.log('update Homework Activity Completed')
                            callback(null, res)
                        })
                    })
                })
            })
        }).catch(err => {
            console.log(err)
            callback(err, null)
        })

        // AssessmentApi.assessMyClickerAssessment(payload).then((res) => {
        //     callback(null, res)
        // }).catch(err => {
        //     callback(err, null)
        // });

    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }

    onPressFinish = () => {
        console.log('finish Pressed')
        this.hideAssessEndPopUp()
        this.assessMyAssessment((err, res) => {
            console.log(err)
            if (err)
                return


            console.log('completed assessment', this.meta, this.props.delegate.showAssessmentEndScreen)
            // this.headerComponent.clearIntervalCustom()

            this.props.delegate && this.props.delegate.showAssessmentEndScreen && this.props.delegate.showAssessmentEndScreen({
                data: res.data,
                percentage: (res.data.markScored / res.data.totalMark) * 100,
                chapterTitle: this.chapterTitle,
                categoryThemeId: this.categoryThemeId,
                assessmentActivityId: this.assessmentActivityId,
                chapterKey: this.chapterKey,
                type: this.meta.type,
                eventId: this.meta.eventId,
                from: this.meta.from,
                selectedChapters: this.meta.selectedChapters,
                scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
                eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},
                isExamPrepKit: this.meta && this.meta.isExamPrepKit ? this.meta.isExamPrepKit : "",
                isFromMyHomework: this.meta && this.meta.isFromMyHomework,
                isDueDatePassed: this.meta && this.meta.isDueDatePassed,
                viewAnswerTime: this.meta && this.meta.viewAnswerTime,
                // from: this.meta.from
            })
        })
    }

    onPressReviewAnswers = () => {

        if (this.state.questionDetailsHash[this.state.questions[0].id]) {
            this.setState({ showFinishFooter: true, index: 0, stepIndex: 0, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
                if (this.assessmentPaginationComponent) {
                    this.assessmentPaginationComponent.scrollTo()
                }
            })
            this.hideAssessEndPopUp()
        } else {
            this.getContents(this.state.questions, 0, (err, response) => {

                if (err)
                    return;

                this.setState({ showFinishFooter: true, index: 0, stepIndex: 0, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                    if (this.assessmentPaginationComponent) {
                        this.assessmentPaginationComponent.scrollTo()
                    }
                })
                this.hideAssessEndPopUp()
            })
        }
    }

    onPressTimeUpContinue = () => {
        this.setState({ showTimeUpPopUp: false })
        this.onPressFinish()
    }

    setCurrentTime = (time) => {
        this.currentTime = time
        this.state.remainingTime = time
        this.setState({ currentTime: time })
    }


    onTimerEnd = () => {

        if (this.ignoreTimeLimit)
            return;

        if (this.state.showAssessEndPopUp) {
            this.setState({ showAssessEndPopUp: false }, () => {
                setTimeout(() => {
                    this.setState({ showTimeUpPopUp: true })
                }, 500)
            })
        } else
            this.setState({ showTimeUpPopUp: true })

    }

    toggleInvalidAnswerModal = (value) => {
        this.setState({ showInvalidAnswerModal: value, questionLoading: false }, () => {
            this.setState({ questionLoading: true })
        });
    }

    onOk = () => {
        this.toggleInvalidAnswerModal(false);
    }




    render() {

        console.log(this.state.questionDetailsHash)
        console.log(this.state.questions)

        let content = this.state.questions && this.state.questions.length ? this.state.questionDetailsHash[this.state.questions[this.state.index].id] : null

        if (this.state.showPreviousQuestion ||
            (this.state.questions[this.state.index] && this.state.questions[this.state.index].answer &&
                this.state.questions[this.state.index].answer.remainingDuration)
        ) {
            let optionsHash = this.state.questions[this.state.index].optionsHash
            content.content.options = Object.values(optionsHash)
            let userIdAnswerHash = this.state.questions[this.state.index].answer
            content.content.duration = userIdAnswerHash.remainingDuration
        }

        console.log(content, this.state.stepIndex, this.state.questions[this.state.index])


        let categoryThemeId = this.categoryThemeId

        // console.log(content, this.state.stepIndex)


        return (


            !this.state.loading ?
                <div className="clicker-assessment-engine">
                    {/* <AssessmentHeader
                        title={this.chapterTitle}
                        categoryThemeId={categoryThemeId}
                        timer={true}
                        time={this.state.remainingTime}
                        delegate={this}
                        ref={(ref) => { this.headerComponent = ref }}
                        isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                    >
                    </AssessmentHeader> */}
                    {/* {
                        this.state.questions && this.state.questions.length ?
                            <AssessmentPagination
                                questions={this.state.questions}
                                activePage={this.state.index + 1}
                                delegate={this}
                                categoryThemeId={categoryThemeId}
                                ref={(ref) => { this.assessmentPaginationComponent = ref }}
                                isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                            />
                            :
                            <></>
                    } */}

                    {this.state.questionLoading ?
                        <div className="question-wrapper ml-5 mt-4">
                            {
                                this.state.questions && this.state.questions.length > 0 &&
                                content && <div>
                                    <MyAssessmentContext.Provider value={{ showFinishFooter: this.state.showFinishFooter, startIndex: this.state.index, isAssessment: this.state.isAssessment, disableNext: this.state.disableNext, showAlphabet: true }}>
                                        <Question delegate={this} ref={(ref) => { this.questionComponent = ref }}
                                            questions={this.state.questions}
                                            // activePage={this.state.index + 1}
                                            activePage={this.state.currentQuestionNumber}
                                            studentList={this.state.studentList}
                                            answer={this.state.questions[this.state.index].answer?.answer}
                                            content={content}
                                            stepIndex={this.state.stepIndex}
                                            showHint={this.state.showHint}
                                            showSolvedExamplesModal={this.state.showSolvedExamplesModal}
                                            showInvalidAnswerModal={this.state.showInvalidAnswerModal}
                                            showCorrectIncorrectModal={this.state.showCorrectIncorrectModal}
                                            showCorrectAnswer={this.state.showCorrectIncorrectScreen}
                                            isAnswerCorrect={this.isCorrect}
                                            categoryThemeId={categoryThemeId}
                                            isFromMyAssessment={true}
                                            isFFF={this.props.isFFF}
                                            userAnswerForReadOnly={this.answer ? this.answer : {}}
                                            optionsHashForReadOnly={this.optionsHash ? this.optionsHash : {}}
                                            showPreviousQuestion={(this.state.index < this.state.currentIndex) ? true : this.state.showPreviousQuestion ? true : false}
                                            autoNext={this.meta.homework.autoNext}
                                            chapterTitle={this.chapterTitle}
                                            showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                                            assessmentActivityId={this.assessmentActivityId}
                                            homeworkId={this.homeworkId}
                                            isFromMyHomework={this.meta.isFromMyHomework}
                                            isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy}
                                            practiceId={this.meta.practice && this.meta.practice.practiceId ? this.meta.practice.practiceId : ''}
                                        // attachments={this.state.questions[this.state.index].attachments ? this.state.questions[this.state.index].attachments : (this.state.attachments[this.state.index] ? this.state.attachments[this.state.index] : [])}
                                        ></Question>
                                    </MyAssessmentContext.Provider>
                                </div>
                            }
                        </div>
                        :
                        <Loading />
                    }

                    {/* {this.state.showFlagPopUp && <FlagPopup close={this.hideFlagPopUp} onPressYes={this.onPressFlagYes} categoryThemeId={categoryThemeId} />} */}
                    {/* {this.state.showAssessEndPopUp && <AssessmentEndPopup flaggedContent={this.flaggedContents} close={this.hideAssessEndPopUp} delegate={this} time={this.currentTime} categoryThemeId={categoryThemeId} liveTimer={this.state.currentTime}
                        isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy} />} */}
                    {/* {this.state.showTimeUpPopUp && <AssessmentEndPopup type="TIMEUP_POPUP" onPressTimeUpContinue={this.onPressTimeUpContinue} categoryThemeId={categoryThemeId} isFromPracticeCaseStudy={this.meta.isFromPracticeCaseStudy} />} */}

                </div>
                :
                <Loading />
        )
    }

}

export default ClickerOfflineAssessmentEngine;